import XLSX from "xlsx";
import FileSaver from "file-saver";
import {ElMessage} from "element-plus";

function _10to62(number) {
  let chars = '0123456789abcdefghigklmnopqrstuvwxyzABCDEFGHIGKLMNOPQRSTUVWXYZ';
  let radix = chars.length;
  let arr = [];
  do {
    let mod = number % radix;
    number = (number - mod) / radix;
    arr.unshift(chars[mod]);
  } while (number);
  return arr.join('');
}

//报表文件导出函数
function _exportTable(excelName) {
  //el-table默认添加id：exportTable
  var exportTable = document.querySelector('#exportTable');
  // 使用 this.$nextTick 是在dom元素都渲染完成之后再执行
  // 设置导出的内容是否只做解析，不进行格式转换     false：要解析， true:不解析
  const xlsxParam = {raw: true}
  const wb = XLSX.utils.table_to_book(exportTable, xlsxParam)
  // 导出excel文件名
  let fileName = excelName + '.xlsx'
  const wbout = XLSX.write(wb, {bookType: 'xlsx', bookSST: true, type: 'array'})
  console.log(exportTable)
  console.log(wb)
  try {
    // 下载保存文件
    FileSaver.saveAs(new Blob([wbout], {type: 'application/octet-stream'}), fileName)
    ElMessage.success("已导出")
  } catch (e) {
    if (typeof console !== 'undefined') {
      console.log(e, wbout)
      ElMessage("文件导出失败,请稍后再试")
    }
  }
  return wbout
}
//报表文件导出函数：文件名称，报表组件css
function _exportTable02(excelName,exportTable) {
  // 使用 this.$nextTick 是在dom元素都渲染完成之后再执行
  // 设置导出的内容是否只做解析，不进行格式转换     false：要解析， true:不解析
  const xlsxParam = {raw: true}
  const wb = XLSX.utils.table_to_book(exportTable, xlsxParam)
  // 导出excel文件名
  let fileName = excelName + '.xlsx'
  const wbout = XLSX.write(wb, {bookType: 'xlsx', bookSST: true, type: 'array'})
  console.log(exportTable)
  console.log(wb)
  try {
    // 下载保存文件
    FileSaver.saveAs(new Blob([wbout], {type: 'application/octet-stream'}), fileName)
    ElMessage.success("已导出")
  } catch (e) {
    if (typeof console !== 'undefined') {
      console.log(e, wbout)
      ElMessage("文件导出失败,请稍后再试")
    }
  }
  return wbout
}
export {
  _10to62,
  _exportTable,
  _exportTable02
}